import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ManagerAccountService } from '../../services/manager-account.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
    selector: 'app-manager-account',
    templateUrl: './manager-account.component.html',
    styleUrls: ['./manager-account.component.scss'],
    standalone: false
})
export class ManagerAccountComponent implements OnInit {
  @Output() delete = new EventEmitter<void>();

  changePasswordForm!: UntypedFormGroup;
  showErrors!: boolean;
  deleteShow = false;
  displayModal$: Observable<boolean>;
  displayModalSubject = new BehaviorSubject(false);
  errorsList!: { [controlId: string]: { [errorKey: string]: string } };

  constructor(private managerAccountService: ManagerAccountService) {
    this.displayModal$ = this.displayModalSubject.asObservable();
  }

  ngOnInit(): void {
    this.changePasswordForm =
      this.managerAccountService.initChangePasswordForm();
    this.showErrors = false;
    this.errorsList = this.managerAccountService.getErrorsList();
  }

  onChangePassword(): void {
    this.showErrors = !this.changePasswordForm.valid;
    if (this.changePasswordForm.valid) {
      const { currentPassword, newPassword, confirmPassword } =
        this.changePasswordForm.value;
      this.managerAccountService
        .changePassword(currentPassword, newPassword, confirmPassword)
        .subscribe(() => this.changePasswordForm.reset());
    }
  }

  onAskDelete(): void {
    this.displayModalSubject.next(true);
  }

  onCancelDeleteAccount(): void {
    this.displayModalSubject.next(false);
  }

  onDeleteAccount(): void {
    this.delete.emit();
  }
}
